// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","877":"component---src-pages-index-bk-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"4caa80f96e28262c4fd4","877":"ebfc951eb4c6c426f582","883":"b8932455e883eb1b29f1"}[chunkId] + ".js";
};